import React, { useEffect, useState } from 'react';
import Button from '@ids/button';
import '../../../stylesheets/interruptiveXsell.scss';
import { useSelector } from 'react-redux';
import { Modal, ModalContent } from '@ids/modal-dialog';
import {
  setSessionStorage,
  getSessionStorage,
  removeSessionStorage,
  getCookie,
  setDocumentCookie,
  createOutOfStockList,
  isProductOutOfStock,
  getImageSrc,
} from '../Util/CommonUtils';
import {
  getXsellProducts,
  getOrderForm,
  updateOrderForm,
} from '../../services/checkoutDataService';
import { productListFetch } from '../../services/productDataService';
import { XsellPricingInformation } from './XsellPricingInformation';
import Loader from '../Common/Loader';
import { FreeShippingPromo } from '../Common/FreeShippingPromo';
import { getXsellImageSource } from '../Util/CheckoutUtil';
import HostedSignIn from '../Header/HostedSignIn';

const InterruptiveXsell = (props) => {
  const [xsellData, setXsellData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [showSignInModal, setShowSignInModal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [outOfStockList, setOutOfStockList] = useState(null);

  let isOutOfStock;
  const cartLimitExceed = () => {
    setOpenModal(true);
  };
  const handleModalClose = () => {
    setOpenModal(false);
  };

  const mainReducer = useSelector((state) => state.mainReducer);


  const closeSignInModal = () => {
    setDocumentCookie('allowGuestCheckout', '1');
    setShowSignInModal(false);
  };

  const openSignInModal = (flag) => {
    setShowSignInModal(flag);
  };

  const getXSellPFIds = () => {
    const XSellPFIds = getSessionStorage('XSellPFIds') ? getSessionStorage('XSellPFIds').value : [];
    removeSessionStorage('XSellPFIds');
    return XSellPFIds;
  };

  useEffect(() => {
    setShowLoader(true);
    setSessionStorage('itemsaddedfrmxsell', '0');
    const XSellPFIds = getXSellPFIds();
    setDocumentCookie('isXSellViewed', '1');
    getXsellProducts({
      state: 'xsell',
      pfId: XSellPFIds,
    })
      .then((interuptiveXSellData) => {
        if (interuptiveXSellData.length < 2) {
          if (!mainReducer.pageData.login) {
            props.history.push('/cartsignin');
          } else {
            props.history.push('/shipping');
          }
        } else {
          // Call GetProductDetails API
          setXsellData(interuptiveXSellData.slice(0, 4));
          const xsellProductList = interuptiveXSellData.slice(0, 4).map((xselDta) => {
            return xselDta.PfId;
          });
          productListFetch(xsellProductList)
            .then((productsData) => {
              setProductData(productsData);
                const ofsList = createOutOfStockList(productsData);
                setOutOfStockList(ofsList);
              setShowLoader(false);
            })
            .catch((err) => {
              setShowLoader(false);
              props.logToIMWebLogger('error', `Xsell: productListFetch call Failed. Error: ${err}`);
            });
          // Send it to analytics
          const p = [];
          const xsell_list = interuptiveXSellData.slice(0, 4);
          if (xsell_list && xsell_list.length > 0) {
            xsell_list.forEach((e) => {
              p.push([e.PfId]);
            });
            props.logToAnalytics({
              aryProducts: p,
              eventList: 'prodview',
            });
          }
        }
      })
      .catch((err) => {
        setShowLoader(false);
        props.logToIMWebLogger('error', `Xsell: getXsellProducts call Failed. Error: ${err}`);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mainReducer.pageData.login]);

  const getSkuList = (id) => {
    return productData.filter((prod) => {
      return prod[0].PfID === id;
    });
  };

  const handleCheckout = () => {
    let allowGuestCheckout = '0';
    if (getCookie('allowGuestCheckout')) {
      allowGuestCheckout = getCookie('allowGuestCheckout');
    }
    if (openModal) {
      setOpenModal(false);
    }
    setShowLoader(true);
    getOrderForm()
      .then((cartdata) => {
        updateOrderForm(cartdata)
          .then(() => {
            setShowLoader(false);
            if (!mainReducer.pageData.login) {
              if (allowGuestCheckout === '0') {
                openSignInModal(true);
              } else {
                props.history.push('/shipping');
              }
            } else {
              props.history.push('/shipping');
            }
          })
          .catch((err) => {
            setShowLoader(false);
            props.logToIMWebLogger('error', `Xsell: updateOrderForm call Failed. Error: ${err}`);
          });
      })
      .catch((err) => {
        setShowLoader(false);
        props.logToIMWebLogger('error', `Xsell: getOrderForm call Failed. Error: ${err}`);
      });
  };

  const handleOutOfStockProductList = (pfid, sku) => {
    isOutOfStock = {
      displayOutOfStock: false,
    };
    if (outOfStockList && outOfStockList.length >= 1) {
      const ofsPfid = isProductOutOfStock(
        {
          pfid,
          sku,
        },
        outOfStockList,
      );
      isOutOfStock = ofsPfid;
      return isOutOfStock;
    }
    return isOutOfStock;
  };

  return (
    <>
      {showLoader && (
        <div style={{ height: '60vh' }}>
          <Loader show={showLoader} size={80} loadingText="Loading.." />
        </div>
      )}
      {!showLoader && (
        <div className="xsell-container">
          <Loader show={showLoader} size={80} loadingText="Loading.." />
          <div className="container-center-lg">
            <div className="margin-main-section">
              <div className="xsell-header-container row">
                <div className="col-lg-10 col-sm-8 col-xs-12 col-order-1">
                  <h1 className="xsell-header">Other people like you buy...</h1>
                </div>
                <div className="col-lg-2 col-sm-4 col-xs-12 xsell-checkout-top col-order-2">
                  <Button
                    theme="intuit"
                    buttonType="primary"
                    className="continue-checkout checkout-btn checkout-primary-btn"
                    onClick={() => {
                      handleCheckout();
                      props.markUserTime('btn_xsell_continue');
                    }}
                    data-wa-link="Continue checkout"
                    data-ui-object="button"
                    data-refer-ui-access-point="continue_checkout_interruptive_xsell_header"
                  >
                    Continue checkout
                  </Button>
                </div>
              </div>
              <div className="xsell-body-container row">
                {xsellData &&
                  xsellData.map((product, key) => {
                    return (
                      <div className="col-sm-6 col-xs-12 xsell-product-container">
                        <div className={key % 2 === 0 ? 'offset-right' : 'offset-left'}>
                          <div className="xsell-product-header">{product.Name}</div>

                          <div className="row">
                            <div className="col-sm-6 col-xs-12">
                              <img
                                src={getImageSrc(getXsellImageSource(product))}
                                alt={product.Name}
                                className="xsell-image"
                                onLoad={() => {
                                  props.markUserTime(`${product.Name}_${key}`);
                                }}
                              />
                            </div>
                            <div className="col-sm-6 col-xs-12">
                              {( handleOutOfStockProductList(product.PfId, null) &&
                                  isOutOfStock &&
                                  !isOutOfStock.displayOutOfStock) && (
                                <XsellPricingInformation
                                  {...props}
                                  skuList={getSkuList(product.PfId)}
                                  pfid={product.PfId}
                                  product={product}
                                  cartLimitExceed={cartLimitExceed}
                                  outOfStockItems={outOfStockList}
                                />
                              )}
                              { handleOutOfStockProductList(product.PfId, null) &&
                                isOutOfStock &&
                                isOutOfStock.displayOutOfStock && (
                                  <div className="product-unavailable-msg">
                                    {isOutOfStock.outOfStockMessage}
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
              <FreeShippingPromo onRequest />
            </div>
          </div>
          <div className="xsell-checkout-bottom">
            <div className="container-center-lg xsell-checout-btm">
              <div className="xsell-footer-container">
                <Button
                  theme="intuit"
                  buttonType="primary"
                  className="continue-checkout-btm checkout-btn checkout-primary-btn"
                  onClick={() => {
                    handleCheckout();
                    props.markUserTime('btn_xsell_continue');
                  }}
                  data-wa-link="Continue checkout"
                  data-ui-object="button"
                  data-refer-ui-access-point="continue_checkout_interruptive_xsell_footer"
                >
                  Continue checkout
                </Button>
              </div>
            </div>
          </div>
          {showSignInModal && (
            <HostedSignIn
              {...props}
              showModal={showSignInModal}
              closeModal={closeSignInModal}
              guest
              location="shipping"
            />
          )}
        </div>
      )}
      ;
      <Modal
        data-wa-link="cart limit exceed modal"
        dismissible
        onClose={handleModalClose}
        open={openModal}
        backdropZIndex={20000}
        size="medium"
      >
        <ModalContent overflow="true" alignment="left">
          <div className="row margin-bottom-15 text-align-left">
            <h3>Your shopping cart is full.</h3>
          </div>
          <div className="row margin-bottom-20 text-align-left">
            <span className="cart-item-remove">
              To buy more products, finish this order and start a new one.
            </span>
          </div>
          <div className="row margin-bottom-40 ">
            <Button
              buttonType="primary"
              theme="quickbooks"
              onClick={handleCheckout}
              data-wa-link="cart limit exceed modal checkout"
              data-ui-object="button"
              data-ui-access-point="modal"
              data-refer-ui-access-point="cart_limit_exceed_modal_checkout"
            >
              Begin checkout
            </Button>
          </div>
          <div className="row note-border text-align-left">
            <span className="discount-note-text">
              If you have questions or need help, call us at (866) 570-3842.
            </span>
          </div>
        </ModalContent>
      </Modal>
    </>
  );
};

export default InterruptiveXsell;
